// extracted by mini-css-extract-plugin
export default {"container":"SearchInput_container__TMPcc","input":"SearchInput_input__5-YD+","searchIcon":"SearchInput_searchIcon__IFGXG"};